import { VENDOR_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const vendorApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Vendor Categories endpoints - CORRECTED for your VENDOR_URL
    getCategoriesByAcademy: builder.query({
      query: (academyId) => ({
        url: `${VENDOR_URL}/vendor-categories/academy/${academyId}`,
        method: "GET",
      }),
      transformResponse: (response) => {
        // Handle both array response and object with categories property
        if (Array.isArray(response)) {
          return response;
        }
        if (response && Array.isArray(response.categories)) {
          return response.categories;
        }
        // Fallback to empty array if unexpected format
        return [];
      },
      providesTags: ["VendorCategories"],
    }),

    createVendorCategory: builder.mutation({
      query: ({ academyId, vendorCategory }) => ({
        url: `${VENDOR_URL}/vendor-categories/${academyId}`,
        method: "POST",
        body: vendorCategory,
      }),
      invalidatesTags: ["VendorCategories"],
    }),

    updateVendorCategory: builder.mutation({
      query: ({ categoryId, vendorCategory }) => ({
        url: `${VENDOR_URL}/vendor-categories/${categoryId}`,
        method: "PUT",
        body: vendorCategory,
      }),
      invalidatesTags: ["VendorCategories"],
    }),

    deleteVendorCategory: builder.mutation({
      query: (categoryId) => ({
        url: `${VENDOR_URL}/vendor-categories/${categoryId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["VendorCategories"],
    }),

    // Vendors endpoints
    createVendor: builder.mutation({
      query: (vendorData) => ({
        url: `${VENDOR_URL}/vendors`,
        method: "POST",
        body: vendorData,
      }),
      invalidatesTags: ["Vendors"],
    }),

    getVendorById: builder.query({
      query: (vendorId) => `${VENDOR_URL}/vendors/${vendorId}`,
      providesTags: (result, error, vendorId) => [
        { type: "Vendor", id: vendorId },
      ],
    }),

    getAllVendors: builder.query({
      query: () => ({
        url: `${VENDOR_URL}/vendors`,
        method: "GET",
      }),
      transformResponse: (response) => {
        // Handle both array response and object with vendors property
        if (Array.isArray(response)) {
          return response;
        }
        if (response && Array.isArray(response.vendors)) {
          return response.vendors;
        }
        // Fallback to empty array if unexpected format
        return [];
      },
      providesTags: ["Vendors"],
    }),

    getVendorsByAcademy: builder.query({
      query: (academyId) => `${VENDOR_URL}/vendors/academy/${academyId}`,
      transformResponse: (response) => {
        // Handle both array response and object with vendors property
        if (Array.isArray(response)) {
          return response;
        }
        if (response && Array.isArray(response.vendors)) {
          return response.vendors;
        }
        // Fallback to empty array if unexpected format
        return [];
      },
      providesTags: ["Vendors"],
    }),

    getVendorsByCategory: builder.query({
      query: (vendorCategoryId) =>
        `${VENDOR_URL}/vendors/category/${vendorCategoryId}`,
      transformResponse: (response) => {
        // Handle both array response and object with vendors property
        if (Array.isArray(response)) {
          return response;
        }
        if (response && Array.isArray(response.vendors)) {
          return response.vendors;
        }
        // Fallback to empty array if unexpected format
        return [];
      },
      providesTags: ["Vendors"],
    }),

    getVendorsByAcademyAndCategory: builder.query({
      query: ({ academyId, vendorCategoryId }) =>
        `${VENDOR_URL}/vendors/academy/${academyId}/category/${vendorCategoryId}`,
      transformResponse: (response) => {
        // Handle both array response and object with vendors property
        if (Array.isArray(response)) {
          return response;
        }
        if (response && Array.isArray(response.vendors)) {
          return response.vendors;
        }
        // Fallback to empty array if unexpected format
        return [];
      },
      providesTags: ["Vendors"],
    }),
    updateVendor: builder.mutation({
      query: ({ vendorId, vendorData }) => ({
        url: `${VENDOR_URL}/vendors/${vendorId}`,
        method: "PUT",
        body: vendorData,
      }),
      invalidatesTags: (result, error, { vendorId }) => [
        "Vendors",
        { type: "Vendor", id: vendorId },
      ],
    }),

    deleteVendor: builder.mutation({
      query: (vendorId) => ({
        url: `${VENDOR_URL}/vendors/${vendorId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Vendors"],
    }),
    checkVendorIdentity: builder.mutation({
      // Changed from query to mutation
      query: ({ vendorIdentity, academyId }) => ({
        // Accept both parameters
        url: `${VENDOR_URL}/vendors/check-identity`,
        method: "POST", // Changed to POST to send both parameters in body
        body: { vendorIdentity, academyId },
      }),
    }),

    // Vendor Visit Logs endpoints - FIXED URLs
    createVisitLog: builder.mutation({
      query: ({ vendorId, visitLog }) => ({
        url: `${VENDOR_URL}/visit-logs/vendors/${vendorId}`, // Removed extra slash at the end
        method: "POST",
        body: visitLog,
      }),
      invalidatesTags: ["VisitLogs"],
    }),
    getVisitLogsByVendor: builder.query({
      query: (vendorId) => ({
        url: `${VENDOR_URL}/visit-logs/vendors/${vendorId}`,
        method: "GET",
      }),
      providesTags: ["VisitLogs"],
    }),

    getVisitLogById: builder.query({
      query: (visitLogId) => `${VENDOR_URL}/visit-logs/${visitLogId}`, // Added /visit-logs/
      providesTags: (result, error, visitLogId) => [
        { type: "VisitLog", id: visitLogId },
      ],
    }),

    updateVisitLog: builder.mutation({
      query: ({ visitLogId, visitLog }) => ({
        url: `${VENDOR_URL}/visit-logs/${visitLogId}`,
        method: "PUT",
        body: visitLog,
      }),
      invalidatesTags: (result, error, { visitLogId }) => [
        "VisitLogs",
        { type: "VisitLogs", id: visitLogId },
      ],
    }),

    deleteVisitLog: builder.mutation({
      query: (visitLogId) => ({
        url: `${VENDOR_URL}/visit-logs/${visitLogId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["VisitLogs"],
    }),
  }),
});

export const {
  // Vendor Categories
  useGetCategoriesByAcademyQuery,
  useCreateVendorCategoryMutation,
  useUpdateVendorCategoryMutation,
  useDeleteVendorCategoryMutation,

  // Vendors
  useCreateVendorMutation,
  useGetVendorByIdQuery,
  useGetAllVendorsQuery,
  useGetVendorsByAcademyQuery,
  useGetVendorsByCategoryQuery,
  useGetVendorsByAcademyAndCategoryQuery,
  useUpdateVendorMutation,
  useDeleteVendorMutation,
  useCheckVendorIdentityMutation,

  // Visit Logs
  useCreateVisitLogMutation,
  useGetVisitLogsByVendorQuery,
  useGetVisitLogByIdQuery,
  useUpdateVisitLogMutation,
  useDeleteVisitLogMutation,
} = vendorApiSlice;
